import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import PlanUsageOutlineButton from './PlanUsageOutlineButton'

/**
 * @param {{ planName: string, priceLine: string, description: string, actionLabel: string, onAction?: () => void }} props
 */
export function PlanUsagePlanTierCardBody({ planName, priceLine, description, actionLabel, onAction }) {
  return (
    <Stack spacing={0.25} alignItems="flex-start" sx={{ width: '100%', minWidth: 0 }}>
      <Stack direction="row" alignItems="center" spacing={0.5} sx={{ flexWrap: 'wrap' }}>
        <Typography component="span" sx={{ fontSize: '0.875rem', fontWeight: 700, lineHeight: '24px', color: 'text.primary' }}>{planName}</Typography>
        <Typography component="span" sx={{ fontSize: '0.875rem', fontWeight: 510, lineHeight: '24px', color: 'text.primary' }}>{priceLine}</Typography>
      </Stack>
      <Typography sx={{ fontSize: '0.75rem', fontWeight: 510, lineHeight: '24px', color: 'text.secondary' }}>{description}</Typography>
      <Box sx={{ pt: 0.25 }}>
        <PlanUsageOutlineButton onClick={onAction} aria-label={actionLabel}>{actionLabel}</PlanUsageOutlineButton>
      </Box>
    </Stack>
  )
}
